import { render } from "./VersionHeaderContainer.vue?vue&type=template&id=426cb07c&ts=true"
import script from "./VersionHeaderContainer.vue?vue&type=script&lang=ts"
export * from "./VersionHeaderContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__